export default __webpack_public_path__ + "static/media/icon_fit_EZfit.e10b74e9.png";